import { render, staticRenderFns } from "./Protection.vue?vue&type=template&id=79e84412&scoped=true"
import script from "./Protection.vue?vue&type=script&lang=js"
export * from "./Protection.vue?vue&type=script&lang=js"
import style0 from "./Protection.vue?vue&type=style&index=0&id=79e84412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e84412",
  null
  
)

export default component.exports